import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    getHabitPeriodProgress,
    getHabitPeriodTargetDays,
    getHabitProgressForDate,
    getHabitTargetCount,
    isHabitDateCompleted,
    isPeriodHabit,
} from '../../utils/habitUtils';
import { PlannerHabitInfo } from './types';

interface ScheduleHabitCardProps {
    getSourceLabel: (folderId: string, collectionId: string) => string;
    onAdvanceHabit: (habitId: string, collectionId: string) => void;
    taskInfo: PlannerHabitInfo;
    todayKey: string;
}

export const ScheduleHabitCard: React.FC<ScheduleHabitCardProps> = ({
    getSourceLabel, onAdvanceHabit, taskInfo: { habit, folderId, collectionId }, todayKey,
}) => {
    const target = isPeriodHabit(habit) ? getHabitPeriodTargetDays(habit, todayKey) : getHabitTargetCount(habit);
    const progress = isPeriodHabit(habit) ? getHabitPeriodProgress(habit, todayKey) : getHabitProgressForDate(habit, todayKey);
    const completed = isHabitDateCompleted(habit, todayKey);
    return (
        <div className={`schedule-habit ${completed ? 'completed' : ''}`}>
            <button type="button" className={`schedule-kind-icon schedule-habit-kind ${completed ? 'is-completed' : ''}`}
                onClick={() => onAdvanceHabit(habit.id, collectionId)} aria-label={habit.title}>
                {completed && <FontAwesomeIcon icon={faCheck} />}
            </button>
            <div className="schedule-habit-details">
                <span className="schedule-element-type schedule-habit-type">Habit</span>
                <span className="schedule-habit-title">{habit.title}</span>
                <span className="schedule-habit-source">{getSourceLabel(folderId, collectionId)}</span>
            </div>
            {target > 1 && <span className="schedule-habit-progress">{progress}/{target}</span>}
        </div>
    );
};
